export const BASE_URL = "/api"
export const HOME_PAGE = process.env.PUBLIC_URL || '/'
export const ENDPOINT = {
    USERS: BASE_URL + '/users',
    STORES: BASE_URL + '/stores',
    REPORTS: BASE_URL + '/reports',
    OPTIONS: BASE_URL + '/setup/options',
    ROLES: BASE_URL + '/roles',
}
